/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ opened: NonNullable<unknown>, updated: NonNullable<unknown> }} Cases_Timeline_Opened_UpdatedInputs */

const en_cases_timeline_opened_updated = /** @type {(inputs: Cases_Timeline_Opened_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opened ${i?.opened} · Updated ${i?.updated}`)
};

const pt_br2_cases_timeline_opened_updated = /** @type {(inputs: Cases_Timeline_Opened_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aberto em ${i?.opened} · Atualizado em ${i?.updated}`)
};

/**
* | output |
* | --- |
* | "Opened {opened} · Updated {updated}" |
*
* @param {Cases_Timeline_Opened_UpdatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_timeline_opened_updated = /** @type {((inputs: Cases_Timeline_Opened_UpdatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Timeline_Opened_UpdatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_timeline_opened_updated(inputs)
	return pt_br2_cases_timeline_opened_updated(inputs)
});